import type { HeroStateConfig } from '@/features/hero/config/hero-states-v2';

/**
 * Campaign/promotional hero states (online build only). They take NO `group`,
 * so each enabled one stacks as an extra carousel slide after the one
 * resolved 'primary' state — unless that state is `exclusive` (payment
 * pending, first session live), which suppresses them.
 *
 * The card layouts own their campaign copy and art; `getTitle` here is only
 * the type-required fallback and is not rendered by the custom cards.
 */
export const PROMO_HERO_STATES: HeroStateConfig[] = [
  {
    id: 'BHANZU_APP_PROMO',
    name: 'Bhanzu App Download Promo',

    cardType: 'bhanzuAppPromo',

    // Same signal as AppDownloadBanner: hide once parent app is registered.
    isEnabled: heroData =>
      !heroData.rawData.selectedProfile?.first_registered?.some(
        registered => registered.source === 'parent_app'
      ),

    getTitle: () => 'Switch to the Bhanzu App',
  },
  {
    id: 'MATH_BEE_PROMO',
    name: 'Math Bee Promo',

    cardType: 'mathBeePromo',

    isEnabled: () => false,

    getTitle: () => "India's Biggest Math Championship Is Here!",
  },
];
